// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetClaimHistoryReport = () =>
    (dispatch, getState) => {

        const dealers = getState().user.details.settings.dealer.accounts.selectedAccounts;

        dispatch({
            type: actions.RESET_CLAIM_HISTORY_REPORT
        });

        dispatch({
            dealers,
            type: actions.SELECT_ALL_CLAIM_HISTORY_DEALERS_ON_LOAD
        });

    };

export const selectCreditMemoProcessDate = creditMemoDate => ({
    creditMemoDate,
    type: actions.SELECT_CREDIT_MEMO_PROCESS_DATE
});

export const updateClaimHistoryCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_CLAIM_HISTORY_CRITERIA,
    value
});

export const selectClaimHistoryClaimType = (claimType, claimTypeCollection) => ({
    claimType,
    claimTypeCollection,
    type: actions.SELECT_CLAIM_HISTORY_CLAIM_TYPE
});

export const selectClaimHistoryDealer = (dealer, dealerCollection) => ({
    dealer,
    dealerCollection,
    type: actions.SELECT_CLAIM_HISTORY_DEALER
});



// WEBPACK FOOTER //
// ./src/reports/claim-history/action-creators/criteria.js